/**
 * Мок Telegram WebApp для локальной разработки без Telegram.
 * Активируется только при REACT_APP_DEV_MODE=true.
 */
const initTelegramMock = () => {
  if (process.env.REACT_APP_DEV_MODE !== 'true') return;
  if (window.Telegram?.WebApp?.initData) return; // уже в Telegram

  console.warn('[DEV MODE] Telegram WebApp замокан для локальной разработки');

  window.Telegram = {
    WebApp: {
      ready: () => {},
      expand: () => {},
      close: () => {},
      disableVerticalSwipes: () => {},
      openLink: (url) => window.open(url, '_blank'),
      onEvent: () => {},
      offEvent: () => {},
      initData: '',
      initDataUnsafe: {
        user: {
          id: 123456789,
          first_name: 'Dev',
          last_name: 'User',
          username: 'dev_user',
          language_code: 'en',
        },
        start_param: '',
      },
      version: '6.0',
      platform: 'web',
      colorScheme: 'light',
      themeParams: {},
      isExpanded: true,
      viewportHeight: window.innerHeight,
      viewportStableHeight: window.innerHeight,
      MainButton: {
        show: () => {},
        hide: () => {},
        setText: () => {},
        onClick: () => {},
        offClick: () => {},
        isVisible: false,
        isActive: true,
      },
      BackButton: {
        show: () => {},
        hide: () => {},
        onClick: () => {},
        offClick: () => {},
        isVisible: false,
      },
    },
  };
};

export default initTelegramMock;
